module.exports = __webpack_public_path__ + "img/adbg_m.a09a45cc.png";